import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=2c50e2b8"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/whitewe_jisheng-mes-ui_CPvN/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c50e2b8')) {
      api.createRecord('2c50e2b8', component.options)
    } else {
      api.reload('2c50e2b8', component.options)
    }
    module.hot.accept("./footer.vue?vue&type=template&id=2c50e2b8", function () {
      api.rerender('2c50e2b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home-page/components/footer.vue"
export default component.exports